module.exports = __webpack_public_path__ + "img/012.0e770513.png";